import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Info } from 'lucide-react'

interface InteriorAnswerProps {
    onNavigate?: () => void
}

const InteriorAnswer: FC<InteriorAnswerProps> = ({ onNavigate }): ReactNode => {
    return (
        <div className='rounded-2xl border-2 border-gold/60 bg-[#fff8e8] p-5 sm:p-6' role='note'>
            <div className='flex items-start gap-4'>
                <Info className='mt-1 size-6 shrink-0 text-navy' aria-hidden='true' />

                <div>
                    <p className='text-lg font-bold text-navy'>
                        We only work on the outside of your home.
                    </p>

                    <p className='mt-2'>
                        The ACM Pros replace exterior windows and install exterior doors. We do not install interior doors, interior windows or do any interior remodeling.
                    </p>

                    <p className='mt-3 flex flex-wrap gap-x-5 gap-y-2'>
                        <Link href='/services/window-replacement/' onClick={onNavigate} className='font-bold text-primary underline underline-offset-4'>
                            Exterior windows
                        </Link>

                        <Link href='/services/door-installation/' onClick={onNavigate} className='font-bold text-primary underline underline-offset-4'>
                            Exterior doors
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default InteriorAnswer
